module.exports = __webpack_public_path__ + "google-dde2415d.png";